import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  delay: number;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  title,
  description,
  delay
}) => {
  const gradients = [
    'from-indigo-500 to-purple-600',
    'from-cyan-500 to-blue-600',
    'from-emerald-500 to-teal-600'
  ];
  
  const gradient = gradients[delay / 100] || gradients[0];

  return (
    <div
      className="group bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 hover:border-indigo-500/50 transition-all duration-500 cursor-pointer hover:transform hover:-translate-y-2 hover:shadow-2xl animate-fade-in"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Background gradient effect */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
      
      <div className={`relative w-16 h-16 bg-gradient-to-br ${gradient} rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
        <Icon className="w-8 h-8 text-white" />
      </div>
      
      <h3 className="relative text-2xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-indigo-400 group-hover:to-purple-400 group-hover:bg-clip-text transition-all duration-300">
        {title}
      </h3>
      
      <p className="relative text-slate-300 leading-relaxed group-hover:text-slate-200 transition-colors duration-300">
        {description}
      </p>
      
      {/* Animated border */}
      <div className={`absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r ${gradient} rounded-full group-hover:w-full transition-all duration-500`}></div>
    </div>
  );
};

export default FeatureCard;